import Title from 'antd/lib/typography/Title';
import { useSearchParams , Navigate} from 'react-router-dom';
import { useAuth } from 'features/auth/hooks';
import accountApis from 'api/accountApis';

export default function LoginPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  var { user } = useAuth();

  const console_token = user || searchParams.get('console_token')

  if(console_token){
    window.localStorage.setItem('console_token', console_token)
    accountApis.getProfile().then(res => {
      if (res && res.data) {
        window.localStorage.setItem('current_account', JSON.stringify(res.data));
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    })
    .catch(() => {});
    return <Navigate to="/" />;
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '100vh',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            alignSelf: 'center',
            justifyContent: 'center',
            marginTop: '-25%'
          }}
        >
          <Title level={2} style={{ textAlign: 'center' }}>
            Chào bạn, vui lòng đăng nhập để tiếp tục
          </Title>

        </div>
      </div>
    </>
  );
}
